import { render, staticRenderFns } from "./StepsLayout.vue?vue&type=template&id=05efdd70&scoped=true&"
import script from "./StepsLayout.vue?vue&type=script&lang=js&"
export * from "./StepsLayout.vue?vue&type=script&lang=js&"
import style0 from "./StepsLayout.vue?vue&type=style&index=0&id=05efdd70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05efdd70",
  null
  
)

export default component.exports